import { isF1Device } from '../utils/isF1Device';

// Read synchronously rather than via useQuery — a synchronous queryFn drives a re-render loop on
// react-query 5.101 (issue #1027). localStorage is the source of truth and the read is cheap.
export const useF1AppVersion = (): string | null => {
  if (!isF1Device()) {
    return null;
  }
  return localStorage.getItem('app_version') ?? localStorage.getItem('ios_app_version');
};
